import React from "react";
import Shirt from "./Shirt";

interface IProps {
  elementType?: number;
  hasShadow?: boolean;
  sizes: string;
}

const PlaceholderShirt: React.FC<IProps> = ({
  elementType,
  hasShadow,
  sizes,
}) => {
  const suffix = elementType === 1 ? `_${elementType}` : "";
  return (
    <Shirt
      hasShadow={hasShadow}
      path={`/dist/img/shirts/standard/shirt_0${suffix}`}
      sizes={sizes}
    />
  );
};

export default PlaceholderShirt;
